<template>
  <div>
    <!-- {{ userList }} -->
    <el-table :data="userList" height="calc(100vh - 360px)">

      <el-table-column prop="channelUserId" label="合伙人UID" fixed="left" align="center" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.channelUserId }}</span>
        </template>
      </el-table-column>
      <el-table-column label="节点总净盈亏(USDT)" width="160">
        <template slot-scope="scope">{{ scope.row.profit }}</template>
      </el-table-column>
      <el-table-column prop="deductedNetProfit" label="节点抵扣后总净盈亏(USDT)" width="200">
        <template slot-scope="scope">
          <span>{{ formatAmount(scope.row.deductedNetProfit) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalFundingFee" label="节点总资金费(USDT)" width="170">
        <template slot-scope="scope">
          <span>{{ formatAmount(scope.row.totalFundingFee) }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="profitAmount" label="节点总盈亏(USDT)" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.profitAmount }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="totalFee"
        label="节点总手续费(USDT)"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.totalFee }}
        </template>
      </el-table-column> -->

      <el-table-column label="节点总净充值(USDT)" width="170">
        <template slot-scope="scope">{{ scope.row.recharge }}</template>
      </el-table-column>
      <el-table-column label="节点总出金(USDT)" width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.txAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column label="节点总入金(USDT)" width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.rechargeAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalContractFee" label="合约汇总手续费(USDT)" width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.totalContractFee }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalSpotFee" label="现货汇总手续费(USDT)" width="170">
        <template slot-scope="scope">
          <span>{{ spotValue(scope.row, 'totalFeeU') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="experienceDeductFee" label="合约体验金抵扣手续费(USDT)" width="210">
        <template slot-scope="scope">
          <span>{{ formatAmount(scope.row.experienceDeductFee) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="experienceFundingFeeDeduct" label="合约体验金资金费抵扣(USDT)" width="210">
        <template slot-scope="scope">
          <span>{{ formatAmount(scope.row.experienceFundingFeeDeduct) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="experiencePnlDeduct" label="合约体验金盈亏抵扣(USDT)" width="210">
        <template slot-scope="scope">
          <span>{{ formatAmount(scope.row.experiencePnlDeduct) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="feeCouponDeduct" label="手续费抵扣券抵扣金额(USDT)" width="220">
        <template slot-scope="scope"><span>{{ formatAmount(scope.row.feeCouponDeduct) }}</span></template>
      </el-table-column>
      <el-table-column prop="pnlCouponDeduct" label="盈亏抵扣券抵扣金额(USDT)" width="220">
        <template slot-scope="scope"><span>{{ formatAmount(scope.row.pnlCouponDeduct) }}</span></template>
      </el-table-column>
      <el-table-column prop="contractRate" label="合约比例" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.contractRate }}%</span>
        </template>
      </el-table-column>
      <el-table-column prop="spotRate" label="现货比例" width="150">
        <template slot-scope="scope">
          <el-tooltip v-if="spotRate(scope.row) === spotText.multi" placement="top" @show="loadIntervals(scope.row)">
            <div slot="content"><div v-for="item in spotIntervals[scope.row.channelUserId] || []" :key="item.id">{{ percent(item.rate) }} · {{ time(item.effective_at) }} — {{ item.effective_until ? time(item.effective_until) : '…' }}</div></div>
            <span>{{ spotText.multi }}</span>
          </el-tooltip>
          <span v-else>{{ spotRate(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="deductContractFee" label="合约扣减手续费(USDT)" width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.deductContractFee }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="deductSpotFee" :label="'现货扣减手续费(' + spotCoin + ')' " width="170">
        <template slot-scope="scope">
          <span>{{ spotValue(scope.row, 'deductFee') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="actualContractFee" label="合约实际手续费(USDT)" width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.actualContractFee }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="actualSpotFee" :label="'现货实际手续费(' + spotCoin + ')' " width="170">
        <template slot-scope="scope">
          <span>{{ spotValue(scope.row, 'actualFee') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="deductContractRebate" label="合约扣减返佣(USDT)" width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.deductContractRebate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="deductSpotRebate" :label="'现货扣减返佣(' + spotCoin + ')' " width="170">
        <template slot-scope="scope">
          <span>{{ spotValue(scope.row, 'deductRebate') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="experienceDeductRebate" label="合约体验金抵扣返佣(USDT)" width="210">
        <template slot-scope="scope">
          <span>{{ formatAmount(scope.row.experienceDeductRebate) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="feeCouponDeductRebate" label="手续费抵扣券抵扣返佣(USDT)" width="220">
        <template slot-scope="scope"><span>{{ formatAmount(scope.row.feeCouponDeductRebate) }}</span></template>
      </el-table-column>
      <el-table-column prop="actualContractRate" label="合约实际返佣(USDT)" width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.actualContractRate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="actualSpotRate" :label="'现货实际返佣(' + spotCoin + ')' " width="170">
        <template slot-scope="scope">
          <span>{{ spotValue(scope.row, 'actualRebate') }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="spotText.paid + ' (' + spotCoin + ')'" width="170"><template slot-scope="s">{{ spotValue(s.row, 'paid') }}</template></el-table-column>
      <el-table-column label="操作" fixed="right" width="110">
        <template slot-scope="scope">
          <el-button v-if="$hasPerm('tenant:partner_funds:view_rebate_detail')" size="mini" type="primary"
            @click="goToRebateDetail(scope.row)">
            查看明细
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pag">
      <pagination :size="pagination.size" :total="totalCount" :page="pagination.page" @pageChanged="pageChanged">
      </pagination>
    </div>

    <!-- <update-dialog
      :val="userinfoDetail"
      :updateForm="updateForm"
    ></update-dialog> -->

    <!-- 编辑用户信息dialog -->
    <!-- <el-dialog
      title="修改备注"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <div class="main">
        <el-card class="box-card">
          <div>备注信息</div>
          <div class="content">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入备注信息"
              maxlength="50"
              show-word-limit
              v-model="textarea2"
            >
            </el-input>
          </div>
          <div class="btn">
            <el-button size="mini" type="primary" @click="add"
              >添 加</el-button
            >
          </div>
        </el-card>
      </div>
  
    </el-dialog> -->
  </div>
</template>

<script>
import { call as spotCall } from '@/components/spot-rebate/api'
import spotLabels from '@/components/spot-rebate/labels'
import BigNumber from 'bignumber.js'
import moment from 'moment'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'
import updateDialog from '../updatedialog'
import { BackgroundColor } from '@icon-park/vue'

export default {
  name: 'UserList',
  props: {
    spotCoin: { type: String, default: "USDT" },
    value1: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      spotRows: {}, spotRequest: 0, spotIntervals: {},
      updateForm: {},
      updateUserTypeDialogVisible: false,
      newUserType: '',
      selectedForUserType: {},
      centerDialogVisible: false,
      textarea2: '',
    }
  },
  components: {
    Pagination,
    updateDialog,
  },
  watch: {
    userList: { immediate: true, handler: 'loadSpot' },
    value1: { deep: true, handler: 'loadSpot' },
    spotCoin: 'loadSpot'
  },
  beforeDestroy() { this.spotRequest++ },
  methods: {
    spotValue(row, key) {
      const value = this.spotRows[row.channelUserId]
      return value && value[key] != null ? new BigNumber(value[key]).toFixed() : '—'
    },
    spotRate(row) { const s = this.spotRows[row.channelUserId]; return !s || s.rateKind === 'NONE' ? '—' : s.rateKind === 'MULTIPLE' ? this.spotText.multi : new BigNumber(s.rates[0]).times(100).toFixed() + '%' },
    percent(value) { return new BigNumber(value).times(100).toFixed() + '%' },
    time(value) { return moment(Number(value)).utcOffset(480).format('YYYY-MM-DD HH:mm:ss') },
    async loadIntervals(row) {
      const request = this.spotRequest
      try {
        const rows = await spotCall(true, '/intervals', { userId: row.channelUserId, coin: this.spotCoin, start: this.value1[0], end: this.value1[1] })
        if (request === this.spotRequest) this.$set(this.spotIntervals, row.channelUserId, rows)
      } catch (e) { if (request === this.spotRequest) this.$message.error('比例生效区间加载失败，请重试') }
    },
    async loadSpot() {
      const request = ++this.spotRequest; this.spotRows = {}; this.spotIntervals = {}
      if (!this.value1 || this.value1.length !== 2) return
      const rows = await Promise.all((this.userList || []).map(async row => {
        try { return [row.channelUserId, await spotCall(true, '/summary', { userId: row.channelUserId, coin: this.spotCoin, start: this.value1[0], end: this.value1[1] })] }
        catch (e) { return [row.channelUserId, null] }
      }))
      if (request === this.spotRequest) { const next = {}; rows.forEach(([key, value]) => { if (value) next[key] = value }); this.spotRows = next }
    },
    ...mapActions('funds', ['addRemark']),
    ...mapMutations('funds', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail',
      'setPagination',
    ]),
    formatAmount(value) {
      return value === null || value === undefined || value === '' ? '--' : value
    },
    goToRebateDetail(row) {
      let startTime, endTime;
      if (this.value1 && this.value1.length > 0) {
        startTime = this.value1[0];
        endTime = this.value1[1];
      }
      const channelUserId =
        row && row.channelUserId != null ? String(row.channelUserId) : "";
      this.$router.push({
        path: "/home/funds/rebate-detail",
        query: {
          channelUserId,
          startTime,
          endTime,
          type: 1,
          coin: this.spotCoin,
        },
      });
    },
    tableRowClassName() {
      // return { 'background-color': '#67c23a','border':'1px solid red' }
      return 'rowClassName'
    },
    rowClass() {
      // return 'background:#E6F1FF;color:#368CFF;font-size:13px'
      ' color: #2AFCFD ; background: #f5f6f9;'
      // return " border-top: 1px solid #1753ac;border-bottom: 1px solid #1753ac; background: rgba(16, 37, 118, 0.5);";
    },
    headClass() {
      // return " color: #2AFCFD ; background: #f5f6f9;";
    },

    pageChanged(pagination) {
      this.$emit('refresh', pagination)
    },
    handleUpdate(row) {
      this.updateForm = row
      // this.setUserinfoDetail(row);
      // this.setUserinfoDetailDialogVisible(true);
      this.centerDialogVisible = true
      this.textarea2 = row.remarks
    },
    add() {
      this.addRemark({
        channelId: this.userInfo.channelId,
        userId: this.updateForm.id,
        remarks: this.textarea2,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('添加成功')
            ; (this.textarea2 = ''), (this.centerDialogVisible = false)
          this.$emit('refresh')
        }
        if (res.code == 1) {
          this.$message.error(res.error.msg)
        }
      })
    },
  },
  computed: {
    spotText() { return spotLabels },
    // ...mapGetters('funds', ['userList']),
    ...mapState(['userInfo']),
    ...mapState('funds', [
      'pagination',
      'userList',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible',
    ]),
  },
}
</script>

<style lang="less" src="../../../../styles/table.less" scoped>
.pag {
  display: flex;
  justify-content: center;
}

.user-type-select {
  width: 100%;
}

.red {
  color: skyblue;
  font-weight: bold;
}

.cc {
  color: #97a0ff;
  font-weight: bold;
}

::v-deep .el-dialog__title {
  color: #6767b3;
  font-size: 24px;
}

::v-deep.el-dialog__headerbtn {
  font-size: 26px;
}

::v-deep .el-dialog__body {
  display: flex;
  justify-content: center;

  .main {
    width: 100%;
    position: relative;

    .box-card {
      width: 100%;
      height: 260px;

      .el-card__body {
        height: 86%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .el-textarea {
          box-shadow:
            0px 0px 1px rgba(24, 26, 32, 0.1),
            0px 3px 6px rgba(71, 77, 87, 0.04),
            0px 1px 2px rgba(24, 26, 32, 0.04);
        }

        .el-textarea__inner {
          padding: 18px 16px;
        }

        .btn {
          display: flex;
          justify-content: center;

          .el-button--primary {
            width: 156px;
            height: 37px;
            background: #707aff;
            border-radius: 4px;
          }
        }
      }
    }
  }
}

::v-deep .el-dialog--center {
  margin-top: 5vh;
  width: 468px;
  // height: 557px;
  background: #f5f6ff;
  border-radius: 8px;
}

// ::v-deep .el-table__body{
//   //-webkit-border-horizontal-spacing: 13px;  // 水平间距
//   -webkit-border-vertical-spacing: 8px;  // 垂直间距
// }
// ::v-deep.el-table th {
//   font-weight: bold;
//   color: #909399;
//   border: none;
// }
// ::v-deep.el-table__header {
//   background-color: #f4f6fa;
// }

// .el-table th, .el-table tr {
//     background-color: #909399;
// }
// ::v-deep.el-table td,
// .el-table th.is-leaf {
//   background-color: #f5f6f9;
//   border: none;
//   outline: none;
//   margin-bottom: 5px;
//   &:nth-child(1) {
//     border-top-left-radius: 12px;
//     border-bottom-left-radius: 12px;
//   }
//   &:nth-last-child(1) {
//     border-top-right-radius: 12px;
//     border-bottom-right-radius: 12px;
//   }
// }
// .el-table::before {
//     left: 0;
//     bottom: 0;
//     width: 100%;
//     height: 0px;
// }</style>
